// extracted by mini-css-extract-plugin
module.exports = {"animation":"HeroAnimation-module--animation--yr9-c","replay":"HeroAnimation-module--replay--2lhYX","visible":"HeroAnimation-module--visible--2jCCK"};